import { render } from "./ViewerModal.vue?vue&type=template&id=22cf5140"
import script from "./ViewerModal.vue?vue&type=script&lang=js"
export * from "./ViewerModal.vue?vue&type=script&lang=js"

import "./ViewerModal.vue?vue&type=style&index=0&id=22cf5140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__